import React from 'react'

function ManufacturingSection() {
  return (
    <section className="ttm-row fid-section ttm-bgimage-yes bg-img1 ttm-bg ttm-bgcolor-darkgrey clearfix">
    <div className="ttm-row-wrapper-bg-layer ttm-bg-layer" />
    <div className="container">
      {/* row */}
      <div className="row">
        <div className="col-lg-8 m-auto">
          {/* section title */}
          <div className="section-title title-style-center_text">
            <div className="title-header">
              <h2 className="title text_change">The Textile, Product, and Apparel <b className="ttm-textcolor-skincolor">Manufacturing </b>Industries.</h2>
            </div>
          </div>{/* section title end */}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 col-md-6 col-sm-6">
          {/* ttm-fid */}
          <div className="ttm-fid inside ttm-fid-with-icon style1">
            <div className="ttm-fid-icon-wrapper">
              <i className="flaticon flaticon-suit" />
            </div>
            <div className="ttm-fid-contents">
              <h4 className="ttm-fid-inner">
                <span data-appear-animation="animateDigits" data-from={0} data-to={350} data-interval={15} data-before data-before-style="sup" data-after data-after-style="sub" className="numinate">350</span>
              </h4>
              <h3 className="ttm-fid-title">Trusted Clients</h3>
            </div>
          </div>{/* ttm-fid end */}
        </div>
        <div className="col-lg-3 col-md-6 col-sm-6">
          {/* ttm-fid */}
          <div className="ttm-fid inside ttm-fid-with-icon style1">
            <div className="ttm-fid-icon-wrapper">
              <i className="flaticon flaticon-fabric" />
            </div>
            <div className="ttm-fid-contents">
              <h4 className="ttm-fid-inner">
                <span data-appear-animation="animateDigits" data-from={0} data-to={215} data-interval={15} data-before data-before-style="sup" data-after data-after-style="span" className="numinate">215
                </span>
              </h4>
              <h3 className="ttm-fid-title">Finished Projects</h3>
            </div>
          </div>{/* ttm-fid end */}
        </div>
        <div className="col-lg-3 col-md-6 col-sm-6">
          {/* ttm-fid */}
          <div className="ttm-fid inside ttm-fid-with-icon style1">
            <div className="ttm-fid-icon-wrapper">
              <i className="flaticon flaticon-factory" />
            </div>
            <div className="ttm-fid-contents">
              <h4 className="ttm-fid-inner">
                <span data-appear-animation="animateDigits" data-from={0} data-to={25} data-interval={15} data-before data-before-style="sup" data-after data-after-style="span" className="numinate">25
                </span>
              </h4>
              <h3 className="ttm-fid-title">Years of Experience</h3>
            </div>
          </div>{/* ttm-fid end */}
        </div>
        <div className="col-lg-3 col-md-6 col-sm-6">
          {/* ttm-fid */}
          <div className="ttm-fid inside ttm-fid-with-icon style1">
            <div className="ttm-fid-icon-wrapper">
              <i className="flaticon flaticon-placeholder" />
            </div>
            <div className="ttm-fid-contents">
              <h4 className="ttm-fid-inner">
                <span data-appear-animation="animateDigits" data-from={0} data-to={45} data-interval={15} data-before data-before-style="sup" data-after data-after-style="span" className="numinate">45
                </span>
              </h4>
              <h3 className="ttm-fid-title">Visited Conferences</h3>
            </div>
          </div>{/* ttm-fid end */}
        </div>
      </div>{/* row end */}
      <div className="row">
        <div className="col-lg-12">
          <div className="margin_top35 mb_15 text-center">
            <p>Don’t hesitate, contact us for better help and services.&nbsp;<a href="services-2.html" className="ttm-textcolor-skincolor font-weight-500"><u>View
                  More!</u></a></p>
          </div>
          <div className="padding_bottom90 res-991-padding_bottom0" />
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default ManufacturingSection